import * as contentful from "contentful"

const client = contentful.createClient({
  space: "mmafv0ion02j",
  accessToken: "xT10LD1KVsu3zclVr3Pn6UjtMjQT9yH-Yb0BrfLl6lk",
})

export default client
